<section class="dialog-content padding-40 text-align-center">
	<a class="close" *ngIf="shouldHideLoadAcVersion" (click)="loadACVersion()"><icon type="times"></icon></a>
	<section class="header">
		<ng-container *ngIf="dialogData.iconType">
			<img ada-decorative [remote-src]="imagePath" onerror="this.style.display = 'none'" />
		</ng-container>
		<p class="text-bold title text-20 padding-top-10" dcrHTMLKey="REIMPORT_TITLE">Are you attempting to reimport this portfolio?</p>
	</section>
	<section class="reimport-body">
		<p class="text-14 padding-top-20" dcrHTMLKey="REIMPORT_TEXT">
			A version of this portfolio exists on the Advisor Center but its holdings/allocations do not match the associated Envestnet portfolio. Changes may have been made since
			last import, either in Advisor Center or Envestnet.
		</p>
		<p class="text-14 padding-top-20" dcrHTMLKey="REIMPORT_CONTINUE_TEXT">Please choose one of the following options to continue.</p>
	</section>

	<section class="grid text-14 padding-top-30">
		<section class="row" [ngClass]="{ 'justify-content-center': shouldHideLoadAcVersion }">
			<section class="col-12 d-flex flex-direction-column">
				<p class="padding-bottom-10 text-bold" dcrHTMLKey="REIMPORT_PORTFOLIO_TEXT">Reimport the Portfolio</p>
				<p class="padding-bottom-30" dcrHTMLKey="OVERWRITE_VERSION_TEXT">Reimport this portfolio and overwrite the version in Advisor Center.</p>
				<button dz-button class="text-16" track-event="reimport-modal:cta:reimport" (click)="reimportPortfolio()" dcrHTMLKey="REIMPORT_LABEL">Reimport</button>
			</section>

			<section *ngIf="!shouldHideLoadAcVersion" class="col-12 d-flex flex-direction-column reimport-section">
				<p dcrHTMLKey="AC_VERSION_TEXT" class="text-bold padding-bottom-10">Go to AC Version</p>
				<p class="padding-bottom-30" dcrHTMLKey="LOAD_AC_PORTFOLIO">Load the Advisor Center version of this portfolio.</p>
				<button dz-button class="text-16" track-event="reimport-modal:cta:load-ac-version" (click)="loadACVersion()" dcrHTMLKey="LOAD_AC_VERSION_LABEL">
					Load AC Version
				</button>
			</section>
		</section>
	</section>
</section>
